import { render } from "./HeaderV1.vue?vue&type=template&id=2126186c&scoped=true&ts=true"
import script from "./HeaderV1.vue?vue&type=script&lang=ts"
export * from "./HeaderV1.vue?vue&type=script&lang=ts"

import "./HeaderV1.vue?vue&type=style&index=0&id=2126186c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2126186c"]])

export default __exports__